import css from 'styled-jsx/css';

export default css`
  .SideBySide {
    margin: 1rem 0;
    clear: both;
    overflow: hidden;
  }
  .SideBySide :global(.Figure) {
    margin-bottom: 1rem;
  }
  .SideBySide--small :global(.Figure) {
    margin: 0 auto 2rem;
    width: 200px;
  }
  .SideBySide--small :global(.Figure__image) {
    border-radius: 50%;
    overflow: hidden;
  }
  @media (min-width: 768px) {
    .SideBySide--small :global(.Figure) {
      margin: 0 1rem 1rem 0;
      float: left;
      width: 70px;
    }
    .SideBySide--large :global(.Figure) {
      margin: 0 1rem 1rem 0;
      float: left;
      width: 334px;
    }
    .SideBySide--small :global(.Figure) {
      width: 160px;
    }
  }
`;
